// CategoryNavigation.js
// Reusable navigation component for project categories

import React from "react";
import { Button } from "react-bootstrap";
import { CATEGORY_INFO, getAllCategories } from "./projectData";

/**
 * CategoryNavigation Component
 * Renders navigation buttons for project categories
 * 
 * @param {string} activeCategory - Currently selected category
 * @param {function} onCategoryChange - Callback function when category changes
 * @param {string} className - Additional CSS classes
 */
function CategoryNavigation({ activeCategory, onCategoryChange, className = "" }) {
  const categories = getAllCategories();

  const handleCategoryClick = (category) => {
    if (onCategoryChange && typeof onCategoryChange === 'function') {
      onCategoryChange(category);
    }
  };

  const getButtonStyle = (category) => ({
    backgroundColor: activeCategory === category ? "#623686" : "transparent",
    borderColor: "#623686",
    color: activeCategory === category ? "white" : "#623686",
    borderWidth: "2px",
    fontWeight: "500",
    transition: "all 0.3s ease",
    minWidth: "160px"
  });

  return (
    <div className={`d-flex justify-content-center flex-wrap gap-3 mb-5 ${className}`}>
      {categories.map((category) => (
        <Button
          key={category}
          onClick={() => handleCategoryClick(category)}
          className="px-4 py-2"
          style={getButtonStyle(category)}
          onMouseEnter={(e) => {
            if (activeCategory !== category) {
              e.target.style.backgroundColor = "#623686";
              e.target.style.color = "white";
            }
          }}
          onMouseLeave={(e) => {
            if (activeCategory !== category) {
              e.target.style.backgroundColor = "transparent";
              e.target.style.color = "#623686";
            }
          }}
        >
          {CATEGORY_INFO[category]?.title || category}
        </Button>
      ))}
    </div>
  );
}

export default CategoryNavigation;